<div class="icon-wrapper">
  <svg attr.width="{{width}}px" attr.height="{{height}}px">
    <use attr.xlink:href="{{url}}#{{src}}"></use>
  </svg>
</div>